// extracted by mini-css-extract-plugin
module.exports = {"link":"link-button_link__UJq__","link-text":"link-button_link-text__KoTs_","link-secondary":"link-button_link-secondary__5lss1"};